import {Provider} from 'react-redux';
import {MantineProvider} from '@mantine/core';
import {globalStore} from './store';
import {Route, Routes} from 'react-router-dom';

import './assets/css/font-icons.css';
import './assets/css/plugins.css';
import './assets/css/drawer.css';
//import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/sass/style.scss';
import {Toaster} from 'react-hot-toast';

import HomeView from './views/Home.view';
import ContactView from './views/Contact.view';
import Contacts from './views/admin/Contacts.view';
import ValuesView from './views/Values.view';
import ExcellenceView from './views/Excellence.view';
import AboutView from './views/About.view';
import HowWeDeliverView from './views/Howwedeliver.view';
import TeamView from './views/Team.view';
import TestimonialsView from './views/Testimonials';
import WhoWeWorkWithView from './views/Whoweworkwith';
import FundingView from './views/Funding.view';
import ServicesView from './views/Services.view';
import SupportedView from './views/Supported.view';
import FindHomeView from './views/FindHome.view';
import ConsultingView from './views/Consulting.view';
import CareView from './views/CareView';
import BrainInjuryView from './views/BrainInjury.view';
import SpinalInjuryView from './views/SpinalInjury.view';
import JobsView from './views/Jobs.view';
import JobDetails from './views/JobDetails.view';
import JobForm from './views/JobForm.view';
import LearningDisabilityView from './views/LearningDisability.view';
import NursingView from './views/Nursing.view';
import NeurologicalView from './views/Neurological.view';
import ChildrenView from './views/Children.view';
import AirwayView from './views/Airway.view';
import RecruitmentView from './views/Recruitment.view';
import WorkWithUsView from './views/WorkWithUs.view';
import TrainingView from './views/Training.view';
import RewardView from './views/Reward.view';
import LoginView from './views/admin/Login.view';

// App component:
function App() {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <Toaster />
      <Provider store={globalStore}>
        <Routes>
          <Route path="/" element={<HomeView />} />
          <Route path="/contact" element={<ContactView />} />
          <Route path="/our-values" element={<ValuesView />} />
          <Route path="/excellence" element={<ExcellenceView />} />
          <Route path="/about-quality" element={<AboutView />} />
          <Route path="/how-we-deliver" element={<HowWeDeliverView />} />
          <Route path="/team" element={<TeamView />} />
          <Route path="/work-with" element={<WhoWeWorkWithView />} />
          <Route path="/funding" element={<FundingView />} />
          <Route path="/our-services" element={<ServicesView />} />
          <Route path="/supported-living" element={<SupportedView />} />
          <Route path="/find-a-home" element={<FindHomeView />} />
          <Route path="/consultation" element={<ConsultingView />} />
          <Route path="/our-care" element={<CareView />} />
          <Route path="/brain-injury" element={<BrainInjuryView />} />
          <Route path="/spinal-injury" element={<SpinalInjuryView />} />
          <Route path="/vacancies" element={<JobsView />} />
          <Route path="/job-details" element={<JobDetails />} />
          <Route path="/job-apply" element={<JobForm />} />
          <Route
            path="/learning-disability"
            element={<LearningDisabilityView />}
          />
          <Route path="/nursing-care" element={<NursingView />} />
          <Route
            path="/neurological-conditions"
            element={<NeurologicalView />}
          />
          <Route path="/children" element={<ChildrenView />} />
          <Route path="/ventilation-and-airway" element={<AirwayView />} />
          <Route path="/recruitment-process" element={<RecruitmentView />} />
          <Route path="/work-with-us" element={<WorkWithUsView />} />
          <Route path="/training" element={<TrainingView />} />
          <Route path="/testimonials" element={<TestimonialsView />} />
          <Route path="/reward" element={<RewardView />} />

          <Route
            path="/quality-healthcare/admin/login"
            element={<LoginView />}
          />
          <Route
            path="/quality-healthcare-admin/contacts"
            element={<Contacts />}
          />
        </Routes>
      </Provider>
    </MantineProvider>
  );
}

export default App;
